import { Component, OnInit, Input } from '@angular/core';
import { FormContentChatComponent } from "../formcontentchat/formcontentchat.component";
import { FormContentChat2Component } from "../formcontentchat2/formcontentchat2.component";
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from "@angular/material";
import { GlobalService } from "../global.service";
import { LoadingScreenService } from "../services/loading-screen/loading-screen.service";
import { Subscription } from "rxjs";
import { Service } from "../services";
import { Router } from "@angular/router";
@Component({
  selector: "app-chat",
  templateUrl: "./chat.component.html",
  styleUrls: ["./chat.component.sass"],
})
export class ChatComponent implements OnInit {
  public token;
  public AccountInfo;
  public selectBan;
  public currentList;
  public postpago;
  public prepago;
  public telefoniaFijo;
  public totalAccountList;
  public code;
  public region;
  public html;
  public origin = "11";
  public subscriber;
  @Input() urlChat = "";
  chatStatus: Subscription;
  loadObserver: Subscription;
  constructor(
    private services: Service,
    private loadingScreenService: LoadingScreenService,
    public dialog: MatDialog,
    private global: GlobalService,
    private router: Router
  ) {}

  ngOnInit() {
    this.global.validateSession();
    this.chatStatus = this.global.chatStatus.subscribe((value: boolean) => {
      this.chat();
    });
    this.loadObserver = this.global.loadObserver.subscribe((value: number) => {
      this.dataLoading(value);
    });
    if (this.global.validateSession() != true  || this.router.url === '/login') {
      this.services
        .botchat(
          "",
          "",
          "",
          "599",
          "e2f7386f-32d3-44ed-8088-0133d11916c6",
          "12",
          "",
          "",
          "",
          "Web",
          ""
        )
        .subscribe((data) => {
          if (data.hasError == false) {
            this.urlChat = data.url;
            sessionStorage.setItem('botChat', data.url);

          }
        });
    }
  }
  chat() {
    if (this.global.validateSession() == true) {

      this.urlChat = sessionStorage.getItem('botChat');
      /*
      const dialogConfig2 = new MatDialogConfig();
        dialogConfig2.disableClose = true;
        dialogConfig2.autoFocus = true;
        dialogConfig2.data = {selectBan : this.selectBan,accountType:this.AccountInfo["accountTypeField"],subscriber:this.subscriber,balance:this.AccountInfo.billBalanceField};
        const dialogRef2 = this.dialog.open(FormContentChatComponent, dialogConfig2);
        dialogRef2.afterClosed().subscribe(value2 => {
          if (value2 == "continue") {

          }
        });*/
      var windS = window.open(
        this.urlChat,
        "Chat Mi Claro",
        "width=400,height=580,scrollbars=NO"
      );
      if (windS == null || typeof windS == "undefined") {
        this.global.notif(
          "Estimado cliente, la ventana ha sido bloqueada por el navegador, para acceder al chat habilite la opcion de la ventana emergente en el navegador."
        );
      }

    } else {
      if (this.urlChat != "") {
        var windS = window.open(
          this.urlChat,
          "Chat Mi Claro",
          "width=400,height=580,scrollbars=NO"
        );
        if (windS == null || typeof windS == "undefined") {
          this.global.notif(
            "Estimado cliente, la ventana ha sido bloqueada por el navegador, para acceder al chat habilite la opcion de la ventana emergente en el navegador."
          );
        }
      } else {
        //si manda una url en blanco
        this.global.notif(
          "En este momento estamos realizando tareas de mantenimiento en nuestro sistema. Por favor intente nuevamente en las próximas horas."
        );
      }
    }
  }
  initializeData() {
    this.global.refreshDataTo(this.token);
  }
  refreshDataTo(event: Event) {
    let index = parseInt(event.target["selectedIndex"]);
    let ban = this.currentList[index].account;
    sessionStorage.setItem("selectBan", btoa(ban));
    this.initializeData();
  }
  dataLoading(sw) {
    if (this.global.validateSession() === true) {
      this.selectBan = atob(sessionStorage.getItem("selectBan"));
      this.AccountInfo = JSON.parse(
        atob(sessionStorage.getItem("getAccountDetails"))
      ).AccounInfo;
    }
  }
  ngOnDestroy() {
    this.chatStatus.unsubscribe();
  }
}
